module.exports = __webpack_public_path__ + "img/grab_pb.69a48a66.jpg";